import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const session = getUserSession()
    const profileFilter = chooseProfileFilter()
    
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [form, setForm] = useState();
    const { id } = useParams();
    
    const hiddenValues = {}


    const path = '/pcontasaccountsrevenues/';
    const paths = {
        endpointSave: config.endpoints.backend + 'pcontasaccountsrevenues/save',
        endpointGetById: config.endpoints.backend + 'pcontasaccountsrevenues/getById',
        endpointGetAllAccountingProjects: config.endpoints.backend + 'accountingprojects/getall',
        endpointGetAllPcontasDocumentTypes: config.endpoints.backend + 'pcontasdocumenttypes/getall',
        endpointGetAllPcontasOriginResources: config.endpoints.backend + 'pcontasoriginresources/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Conta a pagar",
        labelTitleEdit: "Editar Conta a pagar",
        labelTitleView: 'Visualizar Conta a pagar'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_accounting_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllAccountingProjects,
                        label: 'despro',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_pconta_document_type_id',
                    type: 'select',
                    label: 'Tipos de Documentos',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllPcontasDocumentTypes,
                        label: 'description',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_pconta_source_receipt_id',
                    type: 'select',
                    label: 'Tipos de Documentos',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllPcontasOriginResources,
                        label: 'description',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'due_date',
                    type: 'date',
                    label: 'Data de Vencimento',
                    validations: {
                        required: false,
                    },
                    columnSize: 4
                },
                {
                    name: 'competence_date',
                    type: 'date',
                    label: 'Data de Competencia',
                    validations: {
                        required: false,
                    },
                    columnSize: 4
                },
                {
                    name: 'issue_date',
                    type: 'date',
                    label: 'Data de Emissão',
                    validations: {
                        required: false,
                    },
                    columnSize: 4
                },
                {
                    name: 'project_period',
                    type: 'text',
                    label: 'Periodo',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'payment_value',
                    type: 'decimal',
                    label: 'Valor de Pagamento',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'bond_value',
                    type: 'decimal',
                    label: 'Valor do Titulo',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'payment_interest',
                    type: 'decimal',
                    label: 'Valor Juros',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'payment_discount',
                    type: 'decimal',
                    label: 'Desconto',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
